import Service from "../../AuthService";
const Sheet = {
    getSheet(page) {
        return Service.get("/sheet?page="+page);
    },
    showSheet(id) {
        return Service.get("/sheet/" + id);
    },
    updateSheet(id, data) {
        return Service.put("/sheet/" + id, data);
    },
    createSheet(data) {
        return Service.post("/sheet", data);
    },
    deleteSheet(id) {
        return Service.delete("/sheet/" + id);
    },
    searchSheet(page,code) {
        return Service.post("/search-sheet?page="+page+"&code=" + code);
    },
    getSheetType(){
        return Service.get('/sheet_type');
    },
    getAllSheet(){
        return Service.get('/get-all-sheet');
    },
    createSheetType(data){
        return Service.post('/create_sheet_type',data);
    },
    updateSheetType(data){
        return Service.post('/update_sheet_type/'+data.id,data);
    },
};
export default Sheet;
